import type { TInvoiceValues } from '@/modules/perseo-billing/interfaces';

const DEFAULT_PAYLOAD = {
  country: 'CL',
  isInvoice: true,
  latitude: 0,
  longitude: 0
};

const DEFAULT_FORM_VALUES: TInvoiceValues = {
  id: '',
  officialName: '',
  areaOfWork: '',
  address: '',
  addressNumber: null as unknown as number,
  numberOfHouseApartmentOrOffice: '',
  regionId: '',
  communeId: ''
};

const LABEL_CTA_BUTTON = 'Guardar';
const FEEDBACK_SUBTITLE =
  'Si continúas con factura, no podrás pagar con CencoPay ni Gift Card.';
const FEEDBACK_INFO_TITLE = 'Atención';
const FEEDBACK_INFO_SUBTITLE =
  'Verifica que los datos sean correctos antes de continuar.';
const SUBMIT_TOAST_MESSAGE = '¡Listo! Guardaste los datos de facturación';

export {
  DEFAULT_FORM_VALUES,
  DEFAULT_PAYLOAD,
  FEEDBACK_INFO_SUBTITLE,
  FEEDBACK_INFO_TITLE,
  FEEDBACK_SUBTITLE,
  LABEL_CTA_BUTTON,
  SUBMIT_TOAST_MESSAGE
};
